module.exports = __webpack_public_path__ + "images/play-icon-red_59eec715d7b3708d11b7eea25b4ecdea.svg";